<template>
  <div>
    <v-toolbar elevation="0">
      <v-toolbar-title class="primary--text"><h2> Delivery Bookings </h2></v-toolbar-title>
    </v-toolbar>

    <div class="bookings" v-if="!loading">
      <v-container fluid>
        <v-tabs v-model="tab">
          <v-tabs-slider color="black"></v-tabs-slider>
          <v-tab>
            <v-badge
            :content="schedulingBookingData.length"
            color="primary--text"
            >
              SCHEDULING
            </v-badge>
          </v-tab>
          <v-tab>
            <v-badge
            :content="scheduledBookingData.length"
            color="primary--text"
            >
              SCHEDULED
            </v-badge>
          </v-tab>
          <v-tab>
            <v-badge
            :content="droppedBookingData.length"
            color="primary--text"
            >
              DROPPED
            </v-badge>
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <BookingsTable v-bind:bookings="schedulingBookingData" />
          </v-tab-item>
          <v-tab-item>
            <BookingsTable v-bind:bookings="scheduledBookingData" />
          </v-tab-item>
          <v-tab-item>
            <v-btn class="primary" @click="check()">Place a collection</v-btn>
            <v-col md="3">
              <v-text-field v-if="show" label="Enter booking ID" v-model="bookingId"></v-text-field>
            </v-col>
            <v-row v-if="show">
            <v-col>
              <p> Select preferred date and time </p>
            </v-col>
          </v-row>
          <v-row v-if="show">
            <v-col md="3">
              <v-menu
                  v-model="datePicker"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      filled
                      v-model="dateFormatted"
                      label="Date"
                      persistent-hint
                      prepend-inner-icon="mdi-calendar"
                      v-bind="attrs"
                      @blur="date = parseDate(dateFormatted)"
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="date"
                    no-title
                    :min="minDate"
                    @input="datePicker = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col md="3">
              <v-select
                  filled
                  prepend-inner-icon="mdi-clock"
                  label="Time"
                  :items="preferredTimes"
                  v-model="preferredTime"
              ></v-select>
            </v-col>
          </v-row>
            <v-col md="3" align="start" class="mt-n5">
              <v-btn :disabled="disabled" class="primary" v-if="show" @click="updateBooking()"> Collect </v-btn>
            </v-col>
            <BookingsTable v-bind:bookings="droppedBookingData" />
          </v-tab-item>
        </v-tabs-items>
      </v-container>
    </div>
    <div v-if="loading">
      <Loading/>
    </div>
  </div>
</template>

<script>
import BookingsTable from '@/components/bookings/admin/BookingsTable';
import Loading from '@/components/Loading';

export default {
  name: "DeliveryBookings",
  components: {
    Loading,
    BookingsTable
  },
  data() {
    return {
      lastVisible: {},
      tab: '',
      show: false,
      bookingId: '',
      timeStamp: new Date(),
      minDate: new Date().toISOString().substr(0, 10),
      preferredTimes: ['AM', 'PM'],
      date: null,
      dateFormatted: null,
      datePicker: false,
      preferredTime: null,
      loading: false,
      disabled: false
    }
  },
  methods: {
    check(){
      this.show = !this.show;
    },
    formatDate(date){
      if (!date) return null

      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`
    },
    parseDate(date){
      if (!date) return null

      const [day, month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    async updateBooking(){
      this.loading = true;
      if(this.bookingId != '' && this.date && this.preferredTime){
        this.disabled = true
        const id = parseInt(this.bookingId);
        const bookings = this.droppedBookingData;
        const booking = bookings.filter(doc => doc.orderNumber.id === id);
        const originalBooking = Object.assign({}, booking[0]);
        const collection = Object.assign({}, booking[0]);
        collection.arrival = '';
          collection.status = {
            type: 'COLLECTION',
            status: 'SCHEDULING'
          };
          collection.timeStamp = this.timeStamp;
          collection.preferredTime = this.preferredTime;
          collection.preferredDate = this.date;
          delete collection.id;

          await this.$store.dispatch('createBooking', collection);
          this.$store.dispatch('updateBooking', {
            ...originalBooking,
            status:{
              origin: 'DELIVERY'
            }
          });
          alert('Collection successfully created!')
          this.loading = false;
      }
      else{
        alert('Please make sure to fill all the details');
        this.loading = false;
      }
    }

  },
  computed: {
    bookingError() {
      return this.$store.getters['admin/getBookingError'];
    },
    schedulingBookingData() {
      return this.$store.getters['admin/getBookingsByStatus']('SCHEDULING')('DELIVERY')
    },
    scheduledBookingData() {
      return this.$store.getters['admin/getBookingsByStatus']('SCHEDULED')('DELIVERY')
    },
    droppedBookingData() {
      return this.$store.getters['admin/getBookingsByStatus']('DROPPED')('DELIVERY')
    }
  },
  watch: {
    bookingError(error) {
      if (error) {
        alert(error);
      }
    },
    date(){
      this.dateFormatted = this.formatDate(this.date)
    }
  },
  mounted() {
    if(this.$store.state.admin.bookings.length === 0){
      this.$store.dispatch('admin/fetchBookings');
    }
  }
}
</script>

<style scoped>

</style>
